import {} from "@mui/material"
import Dashboard from "./Dashboard"

export default function Admin() {
  return (
  
        <Dashboard />
 
  );
}